import React from "react";

export default function ApprovalCode() {
  return (
    <div className="approval-code">
      <span> CL Code: PM-SA-FPS-WCNT-240001 Preparation date: Feb 2024</span>
    </div>
  );
}
